import styled from 'styled-components';
import C from '@assets/themes/colors';

export const Root = styled.div`
  display: inline-block;
  font-family: Roboto;
`;

export const Col = styled.div`
  width: 300px;
  display:inline-block;  
  position:relative;
`;

export const InputSearch = styled.input`
  height: 48px;
  font-size: 16px;
  text-align: left;
  color: ${C.LIGHT_GRAY};
  padding: 0px 26px 0px 16px;
  border: unset;
  width: 80%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  &::placeholder {
    color: ${C.LIGHT_GRAY};
  }
  &:hover, &:focus {
    color: ${C.DARK_GRAY};
  }
  &:focus {
        outline: none;
  }
`

export const Icon = styled.div`
  position: absolute;
  top: 15px;
  right: 14px;
  cursor: pointer;
`;

export const SearchList = styled.div`
  width: 100%;
  height: auto;
  display: none;
  position: absolute;
  border-radius: 3px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
  z-index: 51;
  margin-top: 7px; 
`;

export const OptionsContaine = styled.div`
  height: auto;
  max-height: 220px;
  overflox-x: hidden;
  overflow-y: auto;
`;

export const Option = styled.div`
  width: auto;
  height: 19px;
  flex-grow: 0;
  padding: 8px 16px;
  background-color: #ffffff;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #272727;
  cursor:pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
  white-space: nowrap;
  &:hover{
    background-color: rgba(18, 36, 66, 0.05);
  }
`;

export const Tag = styled.span`
  display: inline-block;
  color: #8f9fbb;
  text-transform: capitalize;
  margin-left: 4px;
`;